import { CmcWebApi } from '@cmctechnology/webinvest-api-client-web-trading';
import { IExchangeInstrumentQuote, PriceMovement } from './types';
import { QuoteContainerDtoV1 } from '@cmctechnology/webinvest-api-client-market-data-ws';

const toLastPriceMovement = (previousPrice: number, nextPrice: number) => {
  if (previousPrice === 0 || nextPrice === 0) {
    return PriceMovement.Unknown;
  } else if (nextPrice > previousPrice) {
    return PriceMovement.Up;
  } else if (nextPrice < previousPrice) {
    return PriceMovement.Down;
  }
  return PriceMovement.NoChange;
};

export const toLastPriceMovementFromQuoteModel = (
  previousQuote: IExchangeInstrumentQuote | undefined,
  nextQuote: CmcWebApi.MarketInformation.QuoteModel2 | undefined
): PriceMovement => {
  const previousPrice = previousQuote?.extendedTrading?.lastPrice ?? previousQuote?.displayPrice ?? 0;
  const nextPrice = nextQuote?.ExtendedTrading?.LastPrice ?? nextQuote?.DisplayPrice ?? 0;
  return toLastPriceMovement(previousPrice, nextPrice);
};

export const toLastPriceMovementFromQuoteContainerDtoV1 = (
  previousQuote: IExchangeInstrumentQuote | undefined,
  nextQuote: QuoteContainerDtoV1 | undefined,
  nextQuoteExtendedTradingLastPrice: number | undefined
): PriceMovement => {
  const previousPrice = previousQuote?.extendedTrading?.lastPrice ?? previousQuote?.displayPrice ?? 0;
  const nextPrice = nextQuoteExtendedTradingLastPrice ?? nextQuote?.basic?.last ?? 0;
  return toLastPriceMovement(previousPrice, nextPrice);
};
